import axios from "axios";
import config from "../config/config";
import { apiHelper } from "../utils/apiHelper";

const _endpoint = `/api/auth`;

export const authApi = {
  login: (data) =>
    axios(`${_endpoint}/w/sign-in`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data: {
        email: data.email,
        password: data.password,
      },
    }).then((result) => result.data),
  logout: () =>
    axios(`${_endpoint}/logout`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
    }).then((result) => result.data),
  validate: () =>
    axios(`${_endpoint}/w/validate`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
    })
      .then((result) => result.data)
      .catch((err) => apiHelper.handleError(err)),
};
